import React from 'react';

import { Button, Label, TABLE, TD, TH, THEAD, TR } from 'atoms';
import { useTranslation } from 'react-i18next';
import { BLOCKCHAIN_PROTOCOL } from 'pages/exchange/constants';
import { AllInvestorShareWallets } from 'services/apollo/shares';

interface SharesWalletProps {
  whitelistedWallets: AllInvestorShareWallets[];
}

const SharesWalletList: React.FC<SharesWalletProps> = (props) => {
  const { t } = useTranslation();
  const { whitelistedWallets } = props;

  const isProtocolERC1404 = (blockchainProtocol: number) => {
    switch (blockchainProtocol) {
      case BLOCKCHAIN_PROTOCOL.ERC1404_ETHEREUM:
      case BLOCKCHAIN_PROTOCOL.ERC1404_POLYGON:
      case BLOCKCHAIN_PROTOCOL.ERC1404_BINANCE:
        return true;
      default:
        return false;
    }
  };

  const importTokenToWallet = async (address: string, symbol: string, decimals: number) => {
    await window.ethereum.request({
      method: 'wallet_watchAsset',
      params: {
        type: 'ERC20',
        options: {
          address,
          symbol,
          decimals,
        },
      },
    });
  };

  return (
    <>
      <h3> {t('EthereumKeys-WhitelistedWallets-Header')} </h3>
      {whitelistedWallets.length ? (
        <TABLE>
          <THEAD>
            <TR>
              <TH min="100px" max="15%">
                {t('EthereumKeys-WhitelistedWallets-Header-PublicAddress')}
              </TH>
              <TH min="170px" width="100%">
                {t('EthereumKeys-WhitelistedWallets-Header-ShareTitle')}
              </TH>
              <TH min="200px">{t('EthereumKeys-WhitelistedWallets-Header-ShareCount')}</TH>
              <TH min="200px">{t('EthereumKeys-WhitelistedWallets-Header-AddToken')}</TH>
            </TR>
          </THEAD>
          <tbody>
            {whitelistedWallets.map((key) => (
              <TR key={key.ID}>
                <TD>
                  <p className="mt-2">{key.publicKey}</p>
                </TD>
                <TD>
                  <p className="mt-2">{key.shareType.title}</p>
                </TD>
                <TD>
                  <p className="mt-2">{key.shares}</p>
                </TD>
                <TD>
                  {isProtocolERC1404(key.shareType.blockchainProtocolID || 0) && (
                    <Button
                      onClick={() =>
                        importTokenToWallet(
                          key.shareType.ethereumContractAddress ?? '',
                          key.shareType.assetTag ?? '',
                          key.shareType.blockchaindecimals,
                        )
                      }
                    >
                      +
                    </Button>
                  )}
                </TD>
              </TR>
            ))}
          </tbody>
        </TABLE>
      ) : (
        <Label>{t('No-Public-Keys-Found')}</Label>
      )}
    </>
  );
};

export default SharesWalletList;
